export const Filter = {
  YearAndMonth: "yearAndMonth" as const,
  PersonId: "personId" as const,
  PersonName: "personName" as const,
}

